import { create } from 'zustand';

interface BookState {
  activeBookId: string | null;
  activeChapterId: string | null;
  dirty: boolean;
  lastSavedAt: number | null;
  setActiveBook: (id: string | null) => void;
  setActiveChapter: (id: string | null) => void;
  setDirty: (dirty: boolean) => void;
  markSaved: () => void;
}

export const useBookStore = create<BookState>((set) => ({
  activeBookId: null,
  activeChapterId: null,
  dirty: false,
  lastSavedAt: null,
  setActiveBook: (id) => set({ activeBookId: id, activeChapterId: null }),
  setActiveChapter: (id) => set({ activeChapterId: id }),
  setDirty: (dirty) => set({ dirty }),
  markSaved: () => set({ dirty: false, lastSavedAt: Date.now() }),
}));
